var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _rect, _circle9, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3333,
    cy: 12,
    r: 10.5,
    stroke: "param(outline) #fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5475 9.28571C17.5475 12.1655 15.213 14.5 12.3332 14.5C9.45347 14.5 7.11896 12.1655 7.11896 9.28571C7.11896 7.79505 7.7439 6.45091 8.74753 5.5H15.919C16.9226 6.45091 17.5475 7.79505 17.5475 9.28571Z",
    stroke: "param(outline) #fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9048,
    cy: 11.7856,
    r: 0.714286,
    fill: "param(outline) #fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9048,
    cy: 7.49993,
    r: 0.714286,
    fill: "param(outline) #fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7617,
    cy: 11.7856,
    r: 0.714286,
    fill: "param(outline) #fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7617,
    cy: 7.49993,
    r: 0.714286,
    fill: "param(outline) #fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.47607,
    cy: 9.64251,
    r: 0.714286,
    fill: "param(outline) #fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3332,
    cy: 9.64251,
    r: 0.714286,
    fill: "param(outline) #fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1904,
    cy: 9.64251,
    r: 0.714286,
    fill: "param(outline) #fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.83331,
    y: 14.5,
    width: 9,
    height: 5,
    rx: 2.5,
    stroke: "param(outline) #fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1583,
    cy: 16.9749,
    r: 0.825,
    fill: "param(outline) #fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.1583,
    cy: 16.9754,
    r: 0.825,
    fill: "param(outline) #fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcs);
export default __webpack_public_path__ + "static/media/CCS.dc8d38323a6c62558e41bbb83b2aa863.svg";
export { ForwardRef as ReactComponent };